'use client';
import { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { AgentPersonaTab } from './components/AgentPersonaTab';
import { ManualTab } from './components/ManualTab';
import { PageHeader } from './components/PageHeader';

export default function AgentRegistryPage() {
  const [activeTab, setActiveTab] = useState<'agents' | 'manuals'>('agents');

  return (
    <Container className="py-4">
      <PageHeader
        title="AI Agent Registry"
        subtitle="Manage Supervisor Agents, Micro Agents, and Manuals"
      />

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k as 'agents' | 'manuals')} className="mb-4">
        <Tab eventKey="agents" title="Agent Personas">
          <AgentPersonaTab />
        </Tab>
        <Tab eventKey="manuals" title="Manuals">
          <ManualTab />
        </Tab>
      </Tabs>
    </Container>
  );
}

